import { useState } from "react";

export const useUsageData = (adminGatewayStore, userId, month, year) => {
  const [loading, setLoading] = useState(false);
  const [adminTableLoading, setAdminTableLoading] = useState(false);
  const [dedicatedNumbersLoading, setDedicatedNumbersLoading] = useState(false);
  const [purchaseData, setPurchaseData] = useState([]);
  const [oldPurchaseData, setOldPurchaseData] = useState([]);
  const [smsStatusData, setSmsStatusData] = useState(null);
  const [oldSmsStatusData, setOldSmsStatusData] = useState(null);
  const [mmsStatusData, setMmsStatusData] = useState(null);
  const [oldMmsStatusData, setOldMmsStatusData] = useState(null);

  const { getTotalSystemUsage, getUserPurchaseOrders, getUserSenderIds, getTotalSystemPurchase } = adminGatewayStore;

  const fetchAllData = async () => {
    if (!userId) return;

    setLoading(true);
    try {
      const purchaseRes = await getTotalSystemPurchase({ month, year }, userId);
      if (purchaseRes.status) {
        const { currentMonthData, previousMonthData } = purchaseRes.data;
        setPurchaseData(currentMonthData);
        setOldPurchaseData(previousMonthData);
      }

      const usageRes = await getTotalSystemUsage({ month, year }, userId);
      if (usageRes.status) {
        const { currentSmsData, previousSmsData } = usageRes.data;

        setSmsStatusData(currentSmsData.smsData && currentSmsData.smsData.length > 0 ? currentSmsData.smsData[0] : null);
        setOldSmsStatusData(previousSmsData.smsData && previousSmsData.smsData.length > 0 ? previousSmsData.smsData[0] : null);
        setMmsStatusData(currentSmsData.mmsData && currentSmsData.mmsData.length > 0 ? currentSmsData.mmsData[0] : null);
        setOldMmsStatusData(previousSmsData.mmsData && previousSmsData.mmsData.length > 0 ? previousSmsData.mmsData[0] : null);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch purchase orders and sender IDs
  const fetchTablesData = async () => {
    if (!userId) return;

    setAdminTableLoading(true);
    setDedicatedNumbersLoading(true);

    try {
      await getUserPurchaseOrders({ userId, type: "usage", month, year });
      await getUserSenderIds({ userId, type: "usage", month, year });
    } catch (error) {
      console.error("Error fetching tables data:", error);
    } finally {
      setAdminTableLoading(false);
      setDedicatedNumbersLoading(false);
    }
  };

  return {
    loading,
    adminTableLoading,
    dedicatedNumbersLoading,
    purchaseData,
    oldPurchaseData,
    smsStatusData,
    oldSmsStatusData,
    mmsStatusData,
    oldMmsStatusData,
    fetchAllData,
    fetchTablesData
  };
};
